// Google Calendar API Configuration

export const CALENDAR_API_BASE = 'https://www.googleapis.com/calendar/v3';

export const CALENDAR_NAME = 'grownupscalendar2026';

export const CALENDAR_DESCRIPTION = 'Grownups Calendar 2026 - Epic life planning for adults who want to make every moment count!';

// OAuth scopes required for Google Calendar access
export const GOOGLE_SCOPES = [
  'https://www.googleapis.com/auth/calendar',
  'https://www.googleapis.com/auth/calendar.events',
  'https://www.googleapis.com/auth/contacts.readonly'
];

// Default timezone
export const DEFAULT_TIMEZONE = 'Asia/Jerusalem';

// Year we're planning for
export const PLANNING_YEAR = 2026;
